let a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function o(e) {
  var r, i;
  let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(true);
  if (!(t instanceof HTMLElement)) return n;
  let u = false;
  for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) f.remove(), u = true;
  let l = u ? (i = t.innerText) != null ? i : "" : n;
  return a.test(l) && (l = l.replace(a, "")), l;
}
function g(e) {
  let n = e.getAttribute("aria-label");
  if (typeof n == "string") return n.trim();
  let t = e.getAttribute("aria-labelledby");
  if (t) {
    let u = t.split(" ").map((l) => {
      let r = document.getElementById(l);
      if (r) {
        let i = r.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : o(r).trim();
      }
      return null;
    }).filter(Boolean);
    if (u.length > 0) return u.join(", ");
  }
  return o(e).trim();
}
export {
  g as getTextValue
};
